import { useFormContext } from 'react-hook-form';
import { forwardRef } from '@chakra-ui/system';

import Button, { ButtonProps } from 'components/_core/Button';

import { FiscalIdFormSchema } from '../../../../../../form/fiscalIdForm.schema';

interface CancelButtonProps extends ButtonProps {
  onClick: () => void;
}

const CancelButton = forwardRef<CancelButtonProps, 'button'>(
  ({ onClick, ...props }, ref) => {
    const {
      formState: { isLoading },
    } = useFormContext<FiscalIdFormSchema>();

    return (
      <Button
        ref={ref}
        {...props}
        isLoading={isLoading}
        variant="inline-secondary"
      />
    );
  },
);

export default CancelButton;
